import { useEffect, useState } from 'react'

import type { Size } from './edge-anchor'

function currentViewport(): Size {
  return { width: window.innerWidth, height: window.innerHeight }
}

/**
 * The window's size, re-read on every `resize`. Everything placed against the viewport recomputes
 * from this on render — that recomputation IS the stickiness; nothing else moves an element on a
 * resize. Returns the previous object while the size is unchanged, so a no-op `resize` re-renders
 * nothing.
 */
export function useViewportSize(): Size {
  const [size, setSize] = useState<Size>(currentViewport)

  useEffect(() => {
    const onResize = () =>
      setSize(previous => {
        const next = currentViewport()

        return previous.width === next.width && previous.height === next.height ? previous : next
      })

    window.addEventListener('resize', onResize)

    return () => window.removeEventListener('resize', onResize)
  }, [])

  return size
}
